import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { html } from 'lit';
import { escapeHtmlAttribute } from '../shared/escape-html.js';
import { buildUserGreeting, companyBookingMailTemplate, MailTemplateType, MailTemplateVars } from './mail-templates.js';

export const CompanyBookingMail = defineMailTemplate(MailTemplateType.INTERVIEW_BOOKED_COMPANY, {
  //TODO: for some reason mailer does not care about defaultTemplate -> and we need to ensure it on startup
  defaultTemplate: companyBookingMailTemplate,
  variables: [
    MailTemplateVars.COMPANY_FULL_NAME,
    MailTemplateVars.COMPANY_FIRST_NAME,
    MailTemplateVars.COMPANY_LAST_NAME,
    MailTemplateVars.CANDIDATE_FULL_NAME,
    MailTemplateVars.CANDIDATE_FIRST_NAME,
    MailTemplateVars.CANDIDATE_LAST_NAME,
    MailTemplateVars.CANDIDATE_EMAIL,
    MailTemplateVars.JOB_TITLE,
    MailTemplateVars.TIME_SLOT,
    MailTemplateVars.MEETING_LINK,
  ],
  attachments: [],
  displayName: 'Termin gebucht (Unternehmen)',
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Unternehmensnutzer:innen<br />
    </p>
    <p>
      Wann:<br />
      - Wenn Kandidat:in ein Interview gebucht hat
    </p>
  `,
  getMailData: (
    candidateUser: NarrowedEntity<User, { firstName: 1; lastName: 1; username: 1; email: 1 }>,
    companyUser: NarrowedEntity<User, { firstName: 1; lastName: 1; username: 1; email: 1 }>,
    meetingLink: string,
    jobTitle: string,
    timeSlot: string,
  ) => {
    const companyGreeting = buildUserGreeting(companyUser);
    const candidateGreeting = buildUserGreeting(candidateUser);
    return {
      data: {
        [MailTemplateVars.COMPANY_FULL_NAME]: companyGreeting.fullName,
        [MailTemplateVars.COMPANY_FIRST_NAME]: companyGreeting.firstName,
        [MailTemplateVars.COMPANY_LAST_NAME]: companyGreeting.lastName,
        [MailTemplateVars.CANDIDATE_FULL_NAME]: candidateGreeting.fullName,
        [MailTemplateVars.CANDIDATE_FIRST_NAME]: candidateGreeting.firstName,
        [MailTemplateVars.CANDIDATE_LAST_NAME]: candidateGreeting.lastName,
        [MailTemplateVars.CANDIDATE_EMAIL]: candidateUser.email ?? '',
        [MailTemplateVars.JOB_TITLE]: jobTitle,
        [MailTemplateVars.TIME_SLOT]: timeSlot,
        [MailTemplateVars.MEETING_LINK]: escapeHtmlAttribute(meetingLink),
      },
      scope: 'default',
    };
  },
});
